export default __webpack_public_path__ + "static/beefyfinance-8602deb7c4ae61baed7c35965da3142b.jpg";